'use client';

import NossoAcervoView from "@/components/views/NossoAcervo/NossoAcervo";

export default function NossoAcervoClient() {
  return <NossoAcervoView />;
}